const enigmes = {
    enigme1: {
        title: "Chevalier à la cape violette",
coords:"617,635,327,325", 
       shape: "rect",
        text: " Je te remercie pour la bière, l’ami.<br> Mes camarades et moi sommes en attente des instructions de la Couronne pour notre prochaine mission.<br> Certains disent qu’il s’agit d’ordres directs de l’Éclairée. <br>J’aimerais bien t’en dire plus mais les instructions étaient cryptées du Début à la Fin.",
    },
    enigme2: {
        title: "Homme encapuchonné",
 coords:"764,590,982,302",   
     shape: "rect",
        text: "En quoi puis-je vous aider ? <br>Si vous cherchez quelque chose, ça ne doit pas être bien loin.",
    },
    
};
export default enigmes;